<template>
  <header :class="'header fixed' +( $route.name == 'Register' ? ' register-page-header' : '') +(kioskMode ? ' kiosk-on': '')" id="header" v-if="!hideHeader">
    <div :class="'header-top' + (isAgeNotVerifiedPages ? ' no-age-gate-pages' : '') ">
      <div class="container xl"><!-- is-fluid-->
        <div class="level is-mobile align-items-center mb0">
          <!-- Header left start-->
          <div class="level-left">
            <div class="level-item is-flex justify-content-start align-items-center">
              <!-- Logo -->
              <div class="logo">
                <a :href="logoLink" :class="kioskMode ? 'pointer-none':  ''">
                  <img class="main-logo" v-if="vg_businessProfile.branding && vg_businessProfile.branding.logo_url" :src="vg_businessProfile.branding.logo_url" :alt="vg_businessProfile.name"/>
                  <!-- <img v-else src="@/assets/img/logo.png" class="main-logo" alt="logo" /> -->
                </a>
              </div>

              <!-- Current location -->              
              <div class="current-location is-hidden-mobile" v-if="$route.name == 'HomePage'">
                <div class="location-icon" @click.prevent="locateUser()">
                  <img src="@/assets/img/icon-location.svg" alt="image" />
                </div>
                <div class="location-name">
                  <a
                    href="#"
                    @click.prevent="va_setUserAddressModal(true)"
                  >{{ vg_userAddress.formatted_address ? vg_userAddress.formatted_address : 'Set Your Location' }}</a>
                </div>
                <div class="arrow-icon">
                  <img src="@/assets/img/icon-sort-arrows.svg" alt="image" />
                </div>
              </div>

              <div class="header-selected-location" v-if="$route.name != 'HomePage' && $route.name != 'TermsConditions' && $route.name != 'PrivacyPolicy' && $route.name != 'Register' && !isAgeNotVerifiedPages"> <!-- selected location / new header -->

                <template v-if="vg_selectedLocation.id && !kioskMode">
                  <div class="wrapper-store-map-timing"> 
                    <h2 class="store-name has-text-dark has-text-weight-bold">{{ vg_selectedLocation.display_name}}</h2>
                    <div class="dropdown dropdown-open-close-header">
                      <div class="dropdown-trigger">
                        <button
                          class="button"
                          onclick="javascript:document.querySelector('.dropdown-open-close-header').classList.toggle('is-active')"
                          onblur="javascript:document.querySelector('.dropdown-open-close-header').classList.remove('is-active')"
                          aria-haspopup="true"
                          aria-controls="dropdown-menu-header"
                        >
                          <span
                            :class="'availability-status ' + (vg_selectedLocation.currently_open ? ' has-text-green' : ' has-text-red')"
                          >{{ vg_selectedLocation.currently_open ? 'OPEN:' : 'CLOSED'}}</span>

                          <span
                            class="drop-down-spacer has-text-black"
                          >{{ vg_selectedLocation.currently_open ? getTodaysOpenCloseSchedule() : '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' }}</span>
                        </button>
                      </div>
                      <div class="dropdown-menu" id="dropdown-menu-header">
                        <div class="ddown-content">
                          <template v-for="(item, ind) in vg_selectedLocation.hours_of_operation">
                            <a
                              :class="'dropdown-item ' + (item.day == todayDayNumber() ? 'active':'')"
                              :key="ind"
                            >
                              <span
                                class="day has-text-black"
                              >{{item.day_name}} {{ item.day == todayDayNumber() ? '(today)':''}}</span>
                              <span v-if="!item.is_open" class="timing has-text-black">Closed</span>
                              <span v-else class="timing has-text-black">{{getOpenCloseTime(item)}}</span>
                            </a>
                          </template>
                        </div>
                      </div>
                    </div>
                  </div>
                  <p class="store-address has-text-dark is-size-7">
                    <span @click.prevent="getDirection(vg_selectedLocation)" class="header-location-address is-underlined cursor-pointer hover-opacity-6 text-blue">{{ vg_selectedLocation.address ? vg_selectedLocation.address.formatted_address : ''}}</span> 
                    <br/>
                    <a :href="'callto:'+(getContactValue(vg_selectedLocation.contact_details, 'phone', 'value'))" class="has-text-dark" v-if="vg_selectedLocation.contact_details && (vg_selectedLocation.contact_details.length > 0) && getContactValue(vg_selectedLocation.contact_details, 'phone', 'value')" v-html="getContactValue(vg_selectedLocation.contact_details, 'phone', 'value')">
                    </a>
                    <span v-else>&nbsp; <br/></span>
                  </p>
                </template>
                <div class="wrapper-store-map-timing" v-else> 
                  <!-- Place holder so that when location loads it do not flicker content -->
                 <div style="width:1px;height:80px;"/>
                </div>

              </div>
            </div>
          </div>

          <!-- Header right start -->
          <div class="level-right" v-if="($route.name != 'Register'  && $route.name != 'TermsConditions' && $route.name != 'PrivacyPolicy'  && $route.name != 'HelpAndSupport'  && $route.name != 'Faqs' && !isAgeNotVerifiedPages)" >
            <div class="level-item header-right is-flex justify-content-end align-items-center">              
              <div class="header-item is-hidden-mobile">
                <router-link
                  v-if="showOrderNow && access_type == 'internal'"
                  :to="{name: 'StoreLocations', query: $route.query }"
                  class="button is-medium is-primary mr10"
                >Order Now</router-link>
              </div>
              <div class="header-item">
                <ul>
                  <li :class="'header-search-wrap' + (showHeaderSearchbox ? ' active' : '')" v-if="($route.name != 'HomePage') && ($route.name != 'SearchProductResult')">
                      <!-- <a href="#" @click.prevent="open_mobile_header_search = !open_mobile_header_search" class="is-hidden-downto-992 header-search-icon-mob"><i class="fas fa-search"></i></a> -->
                      <div :class="'header-search-box'"><!--  + (search_focus ? 'search-focus-active' : '') -->
                        <form  @submit.prevent="searchProduct($event)" onSubmit="return false;">
                          <input type="text" @focus="search_focus = true" @blur="search_focus = false" name="search" placeholder="Search" v-model="searchText" @keyup.enter="searchProduct($event)"/>
                          <!-- <span class="remove-search-text" @click="removeSearchtext()">
                            <svg width="12" height="12" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path fill-rule="evenodd" clip-rule="evenodd" d="M19.3346 2.54797L17.4546 0.667969L10.0013 8.1213L2.54797 0.667969L0.667969 2.54797L8.1213 10.0013L0.667969 17.4546L2.54797 19.3346L10.0013 11.8813L17.4546 19.3346L19.3346 17.4546L11.8813 10.0013L19.3346 2.54797Z" fill="#445232"/>
                            </svg>
                          </span> -->
                          <button type="button" @click="searchProduct($event)" name="submit-btn" class="hover-opacity-7 search-btn button bg-secondary text-white"><i class="fas fa-search"></i></button>
                        </form>
                      </div>
                  </li>
                  <li class="user-profile">
                    <!-- <span class="unread-notifications at-user-head">1</span> -->
                    <a v-if="is_user_logged_in" href="#" class="sign-in no-underline" @click.prevent>
                      <span class="has-text-dark is-underlined is-size-16px">{{ 'Hi, '+ $store.getters.getLoggedInUser.first_name.slice(0, 20) +'!' }}</span>
                      <span class="has-text-dark is-size-12 no-underline" v-if="vg_userLoyalitySubscriptionObj.points"><em class="font-style-normal has-text-weight-semibold">{{ vg_userLoyalitySubscriptionObj.points ?  new Intl.NumberFormat().format(vg_userLoyalitySubscriptionObj.points) : '0' }}</em> points</span>
                    </a>
                    <a v-else href="#" class="sign-in hover-text-secondary hover-opacity-8 text-secondary has-text-weight-medium no-underline" @click.prevent>
                      JOIN
                    </a>
                    <!-- Login toggle menu -->
                    <div :class="is_user_logged_in ? 'toggle-menu is-hidden' : 'toggle-menu'">
                      <!-- Profile option -->
                      <div class="profile-option">
                        <h3 class="title is-size-5 has-text-centered has-text-black mb20">Welcome!</h3>
                         <a
                          href="#"
                          @click.prevent="va_setSignupModal(true)"
                          class="button mb10 is-full-width bg-secondary text-white has-text-weight-normal is-medium hover-opacity-8"
                        >FIRST TIME</a>
                        <a
                          href="#"
                          @click.prevent="va_setLoginModal(true)"
                          class="button is-full-width is-transparent has-text-weight-normal is-medium hover-opacity-8 mb10"
                        >I ALREADY HAVE AN ACCOUNT</a>
                        <p class="text-center is-size-11 mt10 text-secondary"> 
                          <span class="text-secondary">POWERED BY </span> <img alt="logo" class="vertical-align-inherit powered-logo" src="@/assets/img/logo.png" />
                        </p>
                      </div>
                    </div>
                    <!-- Sign out toggle menu-->
                    <div :class="is_user_logged_in ? 'toggle-menu' : 'toggle-menu is-hidden'">
                      <!-- Profile option -->
                      <div class="profile-option loggedin-user-profile-options pb0">
                        <div class="loggedin-user-basic-details">
                          <p class="has-text-dark is-size-14 name-point">
                            <router-link class="title has-text-dark is-size-5 has-text-dark" 
                              :to="{ 
                                name: 'UserAccountMembership', 
                                params: {business_slug: $route.params.business_slug},
                                query: $route.query
                            }">
                              {{ loggedInUserFullName }}
                            </router-link>
                            <span class="has-text-dark is-size-12 user-points no-underline" v-if="vg_userLoyalitySubscriptionObj.points">
                              <em class="font-style-normal has-text-weight-semibold">{{ vg_userLoyalitySubscriptionObj.points ?  new Intl.NumberFormat().format(vg_userLoyalitySubscriptionObj.points) : '0' }}</em> points
                            </span>
                          </p>
                          <p class="has-text-dark is-size-14 email">{{ loggedInUserEmail }}</p>
                        </div>
                      </div>
                      <!-- Account options using method because route refreshing the page on navigate -->
                      <ul class="account-option-list">
                        <li>
                          <a href="#" :class="'button hover-opacity-9 letter-space-0_5 is-full-width is-medium has-text-weight-medium' + ($route.name == 'UserAccountMembership' ? ' bg-secondary text-white' : '')" @click.prevent="goToUserMembership()">
                            PERKS AND REWARDS
                          </a>
                        </li>

                        <li>
                          <a href="#" :class="'button letter-space-0_5 hover-opacity-9 is-full-width is-medium has-text-weight-medium' + ($route.name == 'UserFavouriteProducts' ? ' bg-secondary text-white' : '')" @click.prevent="goToUserFavouriteProduct()">
                            FAVOURITES
                          </a>
                        </li>

                        <li>
                          <a href="#" :class="'button letter-space-0_5 hover-opacity-9 is-full-width is-medium has-text-weight-medium' +  ($route.name == 'UserOrderHistory' ? ' bg-secondary text-white' : '')" @click.prevent="goToUserOrderHistory()">
                            PAST ORDERS
                          </a>
                        </li>

                        <li>
                          <a href="#" :class="'button letter-space-0_5 hover-opacity-9 is-full-width is-medium has-text-weight-medium' +  ($route.name == 'UserEditAccount' ? ' bg-secondary text-white' : '')" @click.prevent="goToUserEditProfile()">
                            MY INFO
                          </a>
                        </li>

                        <li class="has-text-centered mt10 mb10 is-inline-block">
                          <a
                            href="#"
                            @click.prevent="signOutModal()"
                            class="has-text-weight-medium hover-opacity-7 hover-text-seconday letter-space-0_5 is-full-width text-secondary"
                          >SIGN OUT</a>
                        </li>
 
                      </ul>
                    </div>
                  </li>
                  <!-- <li class="favourite" v-if="!kioskMode">
                    <a href="#" @click.prevent="goToUserFavouriteProduct()"></a>
                  </li> -->
                  <li class="header-search-icon has-inner-svg-secondary hover-opacity-8">
                    <a href="#" @click.prevent="showHeaderSearchbox = !showHeaderSearchbox">
                      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M11.965 11.2578H12.755L17.745 16.2578L16.255 17.7478L11.255 12.7578V11.9678L10.985 11.6878C9.845 12.6678 8.365 13.2578 6.755 13.2578C3.165 13.2578 0.255005 10.3478 0.255005 6.75781C0.255005 3.16781 3.165 0.257812 6.755 0.257812C10.345 0.257812 13.255 3.16781 13.255 6.75781C13.255 8.36781 12.665 9.84781 11.685 10.9878L11.965 11.2578ZM2.255 6.75781C2.255 9.24781 4.26501 11.2578 6.755 11.2578C9.245 11.2578 11.255 9.24781 11.255 6.75781C11.255 4.26781 9.245 2.25781 6.755 2.25781C4.26501 2.25781 2.255 4.26781 2.255 6.75781Z" fill="#010101"/>
                      </svg>
                    </a>
                  </li>
                  <li v-if="($route.name != 'HomePage')" class="shopping-cart is-loaded" data-badge="2">
                    <a @click.prevent="moveToCart()" class="has-inner-svg-secondary hover-opacity-8">
                      <svg class="shopping-cart" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                       <path fill-rule="evenodd" clip-rule="evenodd" d="M18.2961 11.97C17.9561 12.59 17.2961 13 16.5461 13H9.09609L7.99609 15H19.9961V17H7.99609C6.47609 17 5.51609 15.37 6.24609 14.03L7.59609 11.59L3.99609 4H1.99609V2H5.26609L6.20609 4H21.0061C21.7661 4 22.2461 4.82 21.8761 5.48L18.2961 11.97ZM19.3061 6H7.15609L9.52609 11H16.5461L19.3061 6ZM7.99609 18C6.89609 18 6.00609 18.9 6.00609 20C6.00609 21.1 6.89609 22 7.99609 22C9.09609 22 9.99609 21.1 9.99609 20C9.99609 18.9 9.09609 18 7.99609 18ZM16.0061 20C16.0061 18.9 16.8961 18 17.9961 18C19.0961 18 19.9961 18.9 19.9961 20C19.9961 21.1 19.0961 22 17.9961 22C16.8961 22 16.0061 21.1 16.0061 20Z" fill="#616161"/>
                      </svg>
                      <span class="badge bg-secondary" v-if="vg_cartEveryItemCount > 0">{{ vg_cartEveryItemCount }}</span>
                    </a>
                    <div class="cart">
                      <span class="cart-item-weight text-secondary">{{ vg_weightOnCart }}g</span>
                      <span class="total-item-weight text-secondary">/{{ vg_cannabisLimit }}g</span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!-- header right end -->
         
        </div>

         <div :class="'header-search-box-mob' + (showHeaderSearchbox ? ' active' : '')" v-if="($route.name != 'HomePage' &&  $route.name != 'SearchProductResult')">
           <form @submit.prevent="searchProduct($event)" onSubmit="return false;">
            <div class="header-search-box for-mob">
              <input type="search" name="search" placeholder="Search" v-model="searchText" @keyup.enter="searchProduct($event)"/>
              <button type="submit" @click="searchProduct($event)" class="search-btn button text-white hover-opacity-7 bg-secondary"><i class="fas fa-search"></i></button>
            </div>
           </form>
          </div>

      </div>
    </div>
    <div class="header-bottom" v-if="$route.name == 'HomePage'">
      <div class="container is-fluid">
        <!-- current location only show on mobile-->
        <div class="current-location is-hidden-tablet" >
          <div class="location-icon" @click.prevent="locateUser()">
            <img src="@/assets/img/icon-location.svg" alt="image" />
          </div>
          <div class="location-name">
            <a href="#" @click.prevent="va_setUserAddressModal(true)">{{ vg_userAddress.formatted_address ? vg_userAddress.formatted_address : 'Set Your Location' }}</a>
          </div>
          <div class="arrow-icon">
            <img src="@/assets/img/icon-sort-arrows.svg" alt="image" />
          </div>
        </div>
      </div>
    </div>

    <div class="location-notice body-text-dark" v-if="locationNoticeHeader && ($route.name != 'Register') && !isAgeNotVerifiedPages">
      <div class="container xl">
        <div :class="'location-header-notice ' + (locationHeaderNoticeToggle ? 'active' : '')"><p><strong><span v-html="locationNoticeHeader"></span></strong> <span class="notice-more"> To learn more, <a href="#" @click.prevent="locationHeaderNoticeToggle = !locationHeaderNoticeToggle">click here <img class="arrow" src="@/assets/img/expand_more_24px.png"></a></span></p> 
        </div>
        <div class="location-header-notice-content has-text-left has-text-dark body-text-dark mt5 mb5 is-size-16" v-html="locationNotice" v-if="locationHeaderNoticeToggle">
        </div>
      </div>
    </div>

    <slot name="header-foot">
    </slot>
    
    <email-verified-notice />
  </header>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import LocationApis from '@/Components/Controllers/LocationApis';
// import BusinerssProfileApis from '@/Components/Controllers/BusinerssProfileApis';
import Helpers from '@/Components/Helpers/Helpers';
import Env from '@/env';
import moment from 'moment';

export default {
  name: "AppHeader",
  data() {
    return {
      kiosk: false,
      locationHeaderNoticeToggle: false,
      search_focus: false,
      access_type: '', 
      open_mobile_header_search: false,
      searchText: '',
      showOrderNow: true,
      showOnlyOn: ['HomePage'],
      showHeaderSearchbox: false,
      unnecessaryQuery: ['category', 'product_name', 'verify_email', 'token', 'search', 'order_id', 'referral_key', 'signup'],
    };
  },

  props: ["breadcrumb", "title"],

  computed: {
    /**
     * Pages like terms / privacy can see the page so hide heading from them
     */
    isAgeNotVerifiedPages() {
      // if user has verified age then we can set these are verified pages 
      if(this.vg_visitorDetails.ageVerify) {
        return false;
      }
      let hideHeader = ['PrivacyPolicy', 'TermsConditions']; 
      return hideHeader.indexOf(this.$route.name) > -1 ? true : false;
    },

    
     /**
     * Location 
     */
    locationNoticeHeader() {
      if(this.vg_selectedLocation.contact_details){
        return this.getContactValue(this.vg_selectedLocation.contact_details, 'website_notice_header', 'display_value');
      }
      return '';
    },
     /**
     * Location 
     */
    locationNotice() {
      if(this.vg_selectedLocation.contact_details){
        return this.getContactValue(this.vg_selectedLocation.contact_details, 'website_notice', 'display_value');
      }
      return '';
    },
    
     
    /**
     * Location logo url
     */
    logoLink() {
      if(this.kioskMode)  {
        return '#';
      }
      if(this.vg_selectedLocation.contact_details){
        return this.urlify(this.getContactValue(this.vg_selectedLocation.contact_details, 'website', 'display_value'));
      }
      return '#';
    },

    hideHeader() {
      return (this.$route.query['noh'] && ( (this.$route.query['noh'] == 1) || (this.$route.query['noh'] == 'true') )   ) ? true : false;
      // if(this.$route.query.noh && (this.$route.query.noh == 1) ){
      //   return true;
      // }
      // return false;
    },
    is_user_logged_in() {
      return this.$store.getters.getLoggedInUserToken;
    },
    loggedInUserEmail() {
      return this.$store.getters.getLoggedInUser.email;
    },
    loggedInUserFullName() {
      let fullname =  this.$store.getters.getLoggedInUser.first_name + " " + this.$store.getters.getLoggedInUser.last_name;
      if(fullname.length > 30) {
        return fullname.slice(0, 30) + '..';
      }
      return fullname;
    },
    locationName() {
      if (_.isEmpty(this.vg_userAddress)) {
        return "Set Location";
      } else {
        return this.vg_userAddress.name;
      }
    },
    kioskMode() {
      return (this.$route.query['kiosk'] && ( (this.$route.query['kiosk'] == 1) || (this.$route.query['kiosk'] == 'true') ) ) ? true : false;
    },
    ...mapGetters({
      vg_cartItems: "cart/cartItems",
      vg_cartEveryItemCount: "cart/cartEveryItemCount",
      vg_userAddress: "location/userAddress",
      vg_selectedLocation: "location/selected",
      vg_cannabisLimit: "location/cannabis_limit",
      vg_weightOnCart: "cart/cartWeight",
      vg_defaultLocation: "location/default",
      vg_locationNearBy: "location/nearby",
      vg_businessProfile: "businessprofile/detail", 
      vg_guestLandedQueries: "location/guestLandedQueries",
      vg_filters: "searchproduct/searchFilter",  
      vg_userLoyalitySubscriptionObj: "userloyalitysubscription/obj",
      vg_visitorDetails: 'getVisitorDetails',
    }),
  },

  watch:{
    // on location open close watch ofr header height
    locationHeaderNoticeToggle() {
      bus.$emit('recheck-header-height', true)
    },

    // 'vg_locationNearBy': {
    //   handler: function(val, oldVal) {
    //     if(val.locations.length == 0){
    //       // If no nearby location
    //       console.log('null')
    //       this.va_setSelectedLocation({})
    //     } else if (oldVal && oldVal.locations.length == 0 && val.locations.length > 0){
    //       this.va_setSelectedLocation(val.locations[0])
    //     }
    //   },
    //   deep: true,
    //   immediate: true
    // },
    '$route': {
      handler: async function() {
       
        // Hide order now button on this pages
        if( _.indexOf(this.showOnlyOn, this.$route.name) > -1) {
          this.showOrderNow = true
        } else {
          this.showOrderNow = false;
        }
        // Now on route change check check if we have business profile or not 
        if(this.vg_businessProfile.id == ''){
          // then we need to fetch business profile
          // below watching for business profile to fetch locations
          // await BusinerssProfileApis.fetchBusinessProfile(this.$route.params.business_slug); 
        }
        // on changed route empty redirect history
        this.$store.dispatch("SET_USER_LOGIN_REDIRECT",  {});
        // If user chnage route remove add to cart pending
        this.va_setPendingItem({});
      },
      deep: true,
      immediate: true
    },
  
  },
  
  async mounted() {

  

    this.locationHeaderNoticeToggle = false;
    if(this.$route.query.access_type){
      this.access_type = this.$route.query.access_type;
    }
  
  //  if(this.$route.query.search){
  //     // need to trigger search
  //     this.searchText = this.$route.query.search;
  //     this.vg_filters.search = this.$route.query.search;
  //     bus.$emit('filter-now', true)
  //   }
    //window.addEventListener('load', async () => {
      // load data if browser load 
      // let res = await BusinerssProfileApis.fetchBusinessProfile(this.$route.params.business_slug);
      // if(res.status != 200){
      //   // if we dont have valid business slug fall back to default
      //   this.va_snackbar({
      //     type: 'warning', 
      //     message: res.response.data.msg,
      //   });
      //   setTimeout(()=> {
      //     // give time to display message
      //     window.location.href = window.location.origin
      //   }, 200)
      //   //this.$router.push({ path: '/' })
      // } else {
        // If success fetch the nearest location for that business
        //if(this.$route.name == 'StoreProfile' || this.$route.name == 'StoreLanding'){
          // Do not wait for this pages 
        //  LocationApis.fetchNearest(_.isEmpty(this.vg_userAddress) ? '' : this.vg_userAddress.geometry, true);
       // } else {
          // Wait on other page because we need data, for like cart, home, stores
        //  await LocationApis.fetchNearest(_.isEmpty(this.vg_userAddress) ? '' : this.vg_userAddress.geometry, true);
       // }
        
      // }
    // });

   
  },
  methods: {
    /**
     * Convert text to url
     */
    urlify(str) {
      if(!str){
        return '#';
      }
      var regex = /(?:https?):\/\/(\w+:?\w*)?(\S+)(:\d+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
      if(!regex .test(str)) {
        return 'https://'+str;
      } 
      return str;
    },
     /**
     * Get contact value from object
     */
    getContactValue(arr, type, field) {
      let obj = _.find(arr, { 'type': type });
      if (obj != undefined) {
        return obj[field];
      }
      if(type == 'phone'){
        // to maintain space
        return '&nbsp; <br/>';
      }
      return '';
    },
    /**
     * Signout modal open
     */
    signOutModal() {
      bus.$emit("show-modal-sign-out", true);
    },

    /**
     * Go to user membership
     */
    goToUserMembership() {
       this.$router.push({
        name: 'UserAccountMembership',
        params: {
          business_slug: this.$route.params.business_slug
        },
        query:  Helpers.refineQuery( this.unnecessaryQuery, this.$route.query)
      })
    },

    /**
     * Go to Edit profile
     */
    goToUserEditProfile(){
      this.$router.push({
        name: 'UserEditAccount',
        params: {
          business_slug: this.$route.params.business_slug
        },
        query:  Helpers.refineQuery( this.unnecessaryQuery, this.$route.query)
      })
    },

     /**
     * Go to past orders
     */
    goToUserOrderHistory() {
      this.$router.push({
        name: 'UserOrderHistory',
        params: {
          business_slug: this.$route.params.business_slug
        },
        query: Helpers.refineQuery(this.unnecessaryQuery, this.$route.query)
      })
    },

    /**
     * Go to pav product page
     */
    goToUserFavouriteProduct() {
      if(this.$route.name != "UserFavouriteProducts") {
        if(this.$store.getters.getLoggedInUserToken != ''){
          if(_.isEmpty(this.vg_selectedLocation)){
            this.va_snackbar({
              type: 'warning', 
              message:'Please select store to proceed.'
            });
          } else {
            this.$router.push({ 
              name: 'UserFavouriteProducts',
              params: { 
                store_slug: this.vg_defaultLocation.slug 
              },
              query: Helpers.refineQuery(this.unnecessaryQuery, this.$route.query)
            });
          }
        } else {
          this.$store.dispatch("SET_USER_LOGIN_REDIRECT", {
            name: 'UserFavouriteProducts',
            params: {
              business_slug: this.$route.params.business_slug,
              store_slug: this.vg_selectedLocation.slug,
            },
            query:  Helpers.refineQuery(this.unnecessaryQuery, this.$route.query)
          });
          this.va_snackbar({
            type: 'warning', 
            message:'Must login to add favourite.'
          });
        } 
      }
    },

    /**
     * Move to cart
     */
    moveToCart() {
      if(this.vg_selectedLocation.id){
        if(this.$route.name != 'Checkout'){
          bus.$emit('open-sidebar-cart', true);
        } else {
          this.va_snackbar({
            type: 'warning', 
            message: 'Sorry you are already on checkout page.'
          });
        }
      } else {
        this.va_snackbar({
          type: 'warning', 
          message: 'No active location found.'
        });
        // return this.$router.push({ 
        //   name: 'HomePage', 
        //   params: {
        //     business_slug: Env.defaultBusinessSlug 
        //   },
        //   query: this.$route.query,
        // });
      }
    },

    async getLocation() {
      return new Promise((resolve, reject) => {
        if(!("geolocation" in navigator)) {
          reject(new Error('Geolocation is not available.'));
        }
        navigator.geolocation.getCurrentPosition(pos => {
          resolve(pos);
        }, err => {
          reject(err);
        });
      });
    },

    async locateUser() {
      this.va_spinner(true);
      let res = await LocationApis.locateUser();
      this.va_spinner(false);
      if(res.status == 200) {
        this.va_setUserAddress({
          formatted_address: res.address,
          geometry: {
            location: {
              lat: res.lat,
              lng: res.lng,
            }
          },
        });
      } 
      this.va_snackbar({
        message: res.message,
        type: res.status == 200 ? 'success' : 'warning',
      });
    },

    getTodaysOpenCloseSchedule() {
      let todaysSchedule = _.find(this.vg_selectedLocation.hours_of_operation, function (o) { return o.day == new Date().getDay(); });
      if (todaysSchedule != undefined) {
        return this.getOpenCloseTime(todaysSchedule);
      }
      return '';
    },

    todayDayNumber() {
      return new Date().getDay();
    },

     // Get opening and closing time for all the days of week
    getOpenCloseTime(item) {
      return `${moment(item.open_time, "HH:mm:ss").format("hh:mm a")} - ${moment(item.close_time, "HH:mm:ss").format("hh:mm a")}`;
    },


    // Search product
    searchProduct(event) {

      this.$router.push({ 
        name: 'SearchProductResult', 
        params:{
          store_slug: this.vg_selectedLocation.slug,
        },
        query: { ...this.$route.query, ...{product_name: this.searchText.trim() } } 
      })
      // if(this.searchText != this.$route.query.search){
      //   this.$router.replace({ 
      //     query: { search: this.searchText  },
      //   });
      // }
       
  
      // if( (this.searchText.length > 0) && (this.searchText.length < 3) ){
      //   return false;
      // }
      // if(this.$route.name == 'StoreProfile'){
      //   // need to trigger search
      //   this.vg_filters.search = this.searchText;
      //   bus.$emit('filter-now', true)
      // } else {
      //   return this.$router.push({ 
      //     name: 'StoreProfile', 
      //     params:{
      //       business_slug: this.$route.params.business_slug,
      //       store_slug: this.vg_selectedLocation.slug,
      //     },
      //     query: { ...this.$route.query, ...{search: this.searchText.trim() } } 
      //   })
      // }
     
    },

    /**
     * Remove search text
     */
    removeSearchtext() {
      this.searchText = '';
    },
    /**
     * 
     * Open in new tab, location google map
     */
    getDirection(storeDetail) {
      // Open external google map
      if(!_.isEmpty(storeDetail) && !storeDetail.address) {
        return '';
      } else {
        window.open(`https://www.google.com/maps/place/${storeDetail.address.formatted_address}/@${storeDetail.address.latitude},${storeDetail.address.longitude},17.55z'`, '_blank');
      }
    },

    ...mapActions({
      va_setUserAddressModal: "location/setUserAddressModal",
      va_setUserAddress: "location/setUserAddress",
      va_setLoginModal: "loginmodal/setModal",
      va_setSignupModal: "signupmodal/setModal",
      va_snackbar: "snackbar/setSnackbar",
      va_spinner: "spinner/setSpinner",
      va_setSelectedLocation: "location/setSelected",
      va_setPendingItem: "cart/setPendingItem",
    })
  }
};
</script>

<style scoped>
span.unread-notifications {
    width: 20px;
    height: 20px;
    background: #d40000;
    position: absolute;
    right: -28px;
    color: #fff;
    border-radius: 50%;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    top: -9px;
}
.relative{
  position: relative
}
span.unread-notifications.at-user-head {
    top: 4px;
    right: -7px;
    font-size: 9px;
    width: 16px;
    height: 16px;
}
.main-logo{
  max-height: 50px;
}
.location-header-notice {
    display: inline-block;
}
.location-header-notice  p{
  position: relative;
  top: -4px;
}
.location-header-notice a {
  text-decoration: underline;
   margin: 0 5px;
}
.notice-more {
    margin-left: 5px;
    /* display: flex;
    align-items: center; */
}
.notice-more img{
  position: relative;
  top: 7px;
}
.location-header-notice-content p {
    margin-bottom: 15px;
}
.location-header-notice.active img.arrow {
    transform: rotate(180deg);
}
</style>